import React, { Component } from "react";
import { Markup } from "interweave";

class MCViewer extends Component {
  state = {
    Question_ID: this.props.Question_ID,
    Question_Answers: this.props.Question_Answers,
    Response_Required: this.props.Response_Required,
    Answer_ID: this.props.Answer_ID ? this.props.Answer_ID : 0,
    isScale: this.props.isScale,
    isMultiple: this.props.isMultiple,
    inputType: this.props.isMultiple ? 'checkbox' : 'radio',
    SurveyMode: this.props.SurveyMode,
    preloadQAData: this.props.preloadQAData ? this.props.preloadQAData : {},
    CliValidation_Action: this.props.CliValidation_Action ? this.props.CliValidation_Action : undefined
  };

  constructor(props) {
    super(props);
    let preloadQAData = this.state.preloadQAData, Response_Required = this.state.Response_Required, qID = this.state.Question_ID, CliValidation_Action = this.state.CliValidation_Action
    this.state.Question_Answers.filter(function (item) {
      if ((preloadQAData['Answer_Text'] && preloadQAData['Answer_Text'].includes(item['Answer_Text'])) || (CliValidation_Action && item['Answer_Text'].includes((CliValidation_Action).split('=')[1]))) {
        item['isChecked'] = true;
        props.OnUpdate(props.Question_Number, {
          Responses: [
            { Question_ID: qID, Answer_ID: preloadQAData.Answer_ID, Answer_Text: preloadQAData.Answer_Text, Question_Number: props.Question_Number }
          ],
          Response_Required: Response_Required,
        });
      }
      // if(CliValidation_Action && item.Answer_Text.includes((CliValidation_Action).split('=')[1])){
      //   item['isChecked'] = true;
      //   props.OnUpdate(props.Question_Number, {
      //     Responses: [
      //       {
      //         Question_ID: qID,
      //         Answer_ID: item.Answer_ID,
      //         Answer_Text: item.Answer_Text,
      //         Question_Number:props.Question_Number
      //       }
      //     ],
      //     Response_Required: Response_Required,
      //   });
      // }
      return item;
    })
  }

  async componentDidMount(){
    //console.log('MC componentDidMount ', this.state)
  }

  handleSelection = ({ target }) => {
    if (this.state.SurveyMode) {
      let Answer_ID = parseInt(target.value);
      //Deselection
      let isMultiple = this.state.isMultiple,
        Question_Answers = this.state.Question_Answers
      Question_Answers.filter(function (item) {
        if (item['Answer_ID'] === Answer_ID) {
          item['isChecked'] = !item['isChecked']
        }
        else if (!isMultiple) {
          item['isChecked'] = false
        }
        return item
      })
      this.setState({ ...this.state, Question_Answers })
      this.props.OnUpdate(this.props.Question_Number, {
        Responses: [
          {
            Question_ID: this.state.Question_ID,
            Answer_ID: Answer_ID,
            Answer_Text: (this.state.Question_Answers).filter(item => (item['isChecked'])).map(ans => ans['Answer_Text']),
            Question_Number:this.props.Question_Number
          }
        ],
        Response_Required: this.state.Response_Required,
      });
      this.setState({ Answer_ID });
    }
  };

  render() {
    const { Question_Answers, isScale, Question_ID } = this.state;
    return (
      <div className="form-group">
        {Question_Answers.map((ans) => {
          return (
            <div
              className={"form-check" + (isScale ? " form-check-inline" : "")}
              key={Question_ID + "-" + ans.Answer_ID}
            >
              <input
                key={"mc" + ans.Answer_ID}
                type={this.state.inputType}
                className="form-check-input"
                value={ans.Answer_ID}
                name={(this.state.inputType === 'radio') ? "MC" + Question_ID : 'MC' + ans.Answer_ID}
                onClick={this.handleSelection}
                checked={ans.isChecked}
              />
              <label htmlFor={(this.state.inputType === 'radio') ? "MC" + Question_ID : 'MC' + ans.Answer_ID} className="form-check-label">
                <Markup content={ans.Answer_Text} />
              </label>
            </div>
          );
        })}
      </div>
    );
  }
}

export default MCViewer;
